import { useId, useState } from "react";

import { clampProgress } from "ui/alert/alert.helpers";
import { type AlertProps } from "ui/alert/alert.types";

type UseAlertProps = Pick<
  AlertProps,
  "collapsible" | "expanded" | "defaultExpanded" | "onExpandedChange" | "progress"
>;

export const useAlert = ({
  collapsible = false,
  expanded,
  defaultExpanded = false,
  onExpandedChange,
  progress,
}: UseAlertProps) => {
  const titleId = useId();
  const bodyId = useId();
  const [uncontrolledExpanded, setUncontrolledExpanded] = useState(defaultExpanded);

  const isExpanded = !collapsible || (expanded ?? uncontrolledExpanded);

  const handleToggle = () => {
    const next = !isExpanded;

    if (expanded === undefined) {
      setUncontrolledExpanded(next);
    }
    onExpandedChange?.(next);
  };

  const progressValue = progress === undefined ? undefined : clampProgress(progress);

  return {
    titleId,
    bodyId,
    isExpanded,
    handleToggle,
    progressValue,
    hasProgress: progressValue !== undefined,
  };
};
